import axios from 'axios';

const delay = (ms) => new Promise((r) => setTimeout(r, ms));
const MAX_ATTEMPTS = 120; // ~4 minuti con 2s di delay

/**
 * flags: { kw: "0"|"1", pdna: "0"|"1", coff: "0"|"1", olig: "0"|"1" }
 */
export const processPdbId = async (
  apitoken,
  pdbId,
  flags = { kw: "0", pdna: "0", coff: "0", olig: "0" }
) => {
  // 1) ENQUEUE con flags
  const enqueueResp = await axios.post('https://cleanpdb.softmining.it/ws.php', {
    pdbId,
    IDD: apitoken._id,
    Token: '000111',
    serviceName: 'ENQUEUE_CLEANPDB_REQUEST',
    ...flags,
  });
  console.log(`Enqueue for PDB ID: ${pdbId}`, enqueueResp);

  // 2) Poll STATUS con flags + early-exit su ITEM NOT FOUND
  let completed = false;
  for (let attempt = 0; attempt < MAX_ATTEMPTS && !completed; attempt++) {
    const statusResp = await checkCleanPDBStatus(apitoken, pdbId, flags);
    console.log(`Request Status for PDB ID: ${pdbId}`, statusResp);

    const out = statusResp.data?.output || '';
    if (out.includes('REQUEST COMPLETED')) {
      completed = true;
      break;
    }
    await delay(2000);
  }

  if (!completed) {
    const e = new Error('Timeout while waiting for CLEANPDB to complete.');
    e.code = 'TIMEOUT';
    throw e;
  }

  // 3) GET OUTPUT con flags
  const fileResp = await axios.post('https://cleanpdb.softmining.it/ws.php', {
    pdbId,
    IDD: apitoken._id,
    Token: '000111',
    serviceName: 'CLEANPDB_GET_OUTPUT',
    ...flags,
  });
  console.log('Response from CLEANPDB_GET_OUTPUT:', fileResp);

  const pdbContent = fileResp.data?.output;
  if (!pdbContent) {
    const e = new Error('PDB File not exists.');
    e.code = 'NO_OUTPUT';
    throw e;
  }

  const fileBlob = new Blob([pdbContent], { type: 'chemical/x-pdb' });
  const fileUrl = URL.createObjectURL(fileBlob);

  // Nome file: PDB_f1_f2_f3_f4.pdb (f1=kw, f2=pdna, f3=coff, f4=olig)
  const name = `${pdbId}_${flags.kw}_${flags.pdna}_${flags.coff}_${flags.olig}.pdb`;

  return { name, url: fileUrl };
};

/**
 * Nuova funzione: processa una lista di PDB IDs (array di stringhe)
 * Riusa la logica che prima era in processFile.
 */
export const processPdbIdList = async (pdbIds, apitoken, flags) => {
  const results = [];
  const errors = [];

  for (const raw of pdbIds) {
    const pdb = raw.toUpperCase();
    try {
      const res = await processPdbId(apitoken, pdb, flags);
      results.push(res);
    } catch (err) {
      console.error(`Failed processing ${pdb}:`, err);
      errors.push({
        pdb,
        code: err?.code || 'UNKNOWN',
        message: err?.message || String(err),
      });
      // continua con i successivi
    }
  }

  // Se nessun risultato valido, lancia errore aggregato
  if (results.length === 0) {
    const e = new Error('No valid results (all failed or ITEM NOT FOUND).');
    e.code = 'NO_VALID_RESULTS';
    e.details = errors;
    throw e;
  }

  return results;
};

/**
 * Rimane per compatibilità: legge un file .txt,
 * estrae i PDB IDs e chiama processPdbIdList.
 */
export const processFile = async (file, apitoken, flags) => {
  const fileText = await file.text();
  const pdbIds = fileText
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean);

  return processPdbIdList(pdbIds, apitoken, flags);
};

export const checkCleanPDBStatus = async (
  apitoken,
  pdbId,
  flags = { kw: "0", pdna: "0", coff: "0", olig: "0" }
) => {
  const response = await axios.post('https://cleanpdb.softmining.it/ws.php', {
    pdbId,
    IDD: apitoken._id,
    Token: '000111',
    serviceName: 'CLEANPDB_REQUEST_STATUS',
    ...flags,
  });

  const out = response.data?.output;

  // intercetta varianti di ITEM NOT FOUND dal backend e lancia errore
  if (
    out === 'ITEM NOT FOUND' ||
    out === 'ITEM_NOT_FOUND' ||
    out === 'Item_not_found'
  ) {
    const e = new Error('Item not found');
    e.code = 'ITEM_NOT_FOUND';
    throw e;
  }

  return response;
};
